import { z } from "zod";

export const perfilSchema = z.object({
  nomeCompleto: z.string().min(2, "Informe o nome completo"),
  especialidade: z.string().optional().or(z.literal("")),
  crm: z.string().optional().or(z.literal("")),
  razaoSocialPj: z.string().optional().or(z.literal("")),
  cnpjPj: z.string().optional().or(z.literal("")),
  emailNotificacao: z.string().email("E-mail inválido").optional().or(z.literal("")),
  regimeTributario: z.enum(["simples_nacional", "lucro_presumido", "lucro_real", ""]).optional(),
});
